"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Toaster.default;
  }
});
Object.defineProperty(exports, "notify", {
  enumerable: true,
  get: function get() {
    return _Toaster.notify;
  }
});
Object.defineProperty(exports, "toast", {
  enumerable: true,
  get: function get() {
    return _Toaster.toast;
  }
});
Object.defineProperty(exports, "ToastContainer", {
  enumerable: true,
  get: function get() {
    return _ToastContainer.default;
  }
});
Object.defineProperty(exports, "ToastTitle", {
  enumerable: true,
  get: function get() {
    return _AlertStyled.StyledAlertTitle;
  }
});
Object.defineProperty(exports, "ToastMessage", {
  enumerable: true,
  get: function get() {
    return _AlertStyled.StyledAlertMessage;
  }
});

var _Toaster = _interopRequireWildcard(require("./Toaster"));

var _ToastContainer = _interopRequireDefault(require("./ToastContainer"));

var _AlertStyled = require("../Alert/Alert-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }